import { PortfolioIds } from '../enums/portfolio-ids.enum';

export const PortfolioColors = {
  [PortfolioIds.RA_CAPITAL]: '#2A6EF6',
  [PortfolioIds.BLACKWELL]: '#68A800',
  [PortfolioIds.NEXUS]: '#003552',
  [PortfolioIds.NEXUS_2]: '#9EC0D1',
  [PortfolioIds.NEXUS_3]: '#21908F'
};
